import React, { useContext } from 'react';
import { findByAlias, findByAliasV1, findByPathV1 } from '../../../routes';
import { OsbMainWrapperView, PageNotFoundView } from '../../../views';
import { useParams } from 'react-router-dom';
import ServerContext from '../../../contexts/serverContext';
import { VehicleStepView } from '../../../views/osb-v3-view/vehicle-step-view/vehicle-step-view';
import { CancelConfirmStepView } from '../../../views/osb-v3-view/cancel-confirm-step-view/cancel-amend-confirmation';
import { ContactDetailsStepView } from '../../../views/osb-v3-view/contact-details-step-view/contact-details-step-view';
import { ServiceStepView } from '../../../views/osb-v3-view/service-step-view/service-step-view';
import { RetrieveAccessCodePageView } from '../../../views/osb-v3-view/retrieve-access-code-view/retrieve-access-code-view';
import { FindBookingView } from '../../../views/osb-v3-view/find-booking-view/find-booking-view';

export const OsbPathStartStep = (): string => {
    return findByAlias('OsbV3InitialView');
};
export const OsbPathVehicleStep = (): string => {
    return findByAlias('OsbV3VehicleStepView');
};
export const OsbPathServiceCentreStep = (): string => {
    return findByAlias('OsbV3ServiceCentreStepView');
};
export const OsbPathServiceStep = (): string => {
    return findByAlias('OsbV3ServiceStepView');
};
export const OsbBookingConfirmationView = (): string => {
    return findByAlias('OsbV3BookingConfirmationView');
};

export const OsbPathCancelConfirmStep = (): string => {
    return findByAlias('OsbV3CancelConfirmStepView');
};

export const OsbPathContactDetailsStep = (): string => {
    return findByAlias('OsbV3ContactDetailsStepView');
};

export const OSBPathFindBookingStep = (): string => {
    return findByAlias('OsbV3FindBookingStepView');
};

export const OSBPathRetrieveAccessCodeView = (): string => {
    return findByAlias('OsbV3RetrieveAccessCodeView');
};

const osbViewSelector = (componentName: string | undefined) => {
    switch (componentName) {
        case 'OsbV3InitialView':
            return <></>;
        case 'OsbV3VehicleStepView':
            return <VehicleStepView />;
        case 'OsbV3ServiceStepView':
            return <ServiceStepView />;
        case 'OsbV3CancelConfirmStepView':
            return <CancelConfirmStepView />;
        case 'OsbV3ContactDetailsStepView':
            return <ContactDetailsStepView />;
        case 'OsbV3FindBookingStepView':
            return <FindBookingView />;
        case 'OsbV3RetrieveAccessCodeView':
            return <RetrieveAccessCodePageView />;
        default:
            return <PageNotFoundView />;
    }
};
export const OsbV3ViewWrapper: React.FunctionComponent = (): React.JSX.Element => {
    const context = useContext(ServerContext);
    const { view: viewPath } = useParams<{ view: string }>();

    let basePath: string;
    const b = findByAliasV1(
        'OsbV3ViewWrapper',
        context.domain,
        context.brand,
        context.currentLanguageRegionCode
    );

    if (b !== undefined) {
        if (typeof b == 'string') {
            basePath = b;
        } else {
            basePath = b[0];
        }
    } else basePath = 'OsbV3InitialView'; // this should never happen
    let component;
    if (viewPath) {
        component = findByPathV1(
            basePath + '/' + viewPath,
            context.domain,
            context.brand,
            context.currentLanguageRegionCode
        );
    } else {
        component = 'OsbV3InitialView';
    }
    return (
        <OsbMainWrapperView>{osbViewSelector(component)}</OsbMainWrapperView>
    );
};
export default OsbV3ViewWrapper;
